import { Component, input } from '@angular/core'

@Component({
  selector: 'dhp-error-toast',
  templateUrl: './error-toast.component.html',
})
export class ErrorToastComponent {
  readonly message = input<string | null>(null)
}
